import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsPhuongXaTheoIdTinhThanh } from '../../services/danhmuc';

const PhuongXaSelectBox = ({ idTinhThanh, value, optionAll, onChange }: { idTinhThanh? : number; value?: number | null, optionAll?: boolean, onChange: (e: any) => void }) => {
	const [data, setData] = useState<Array<DataSelectBox>>([]);
	const layDuLieu = async () => {
		try {
			let rs = await layDsPhuongXaTheoIdTinhThanh(idTinhThanh || 0);
			if (rs.length == 0) {
				rs = [{ value: 0, label: "--Không có--" }, ...rs];
			} else {
				if (optionAll && rs.length > 1) {
					rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
				}
			}
			setData(rs);
			const isValid = rs.some(x => x.value === value);

			if (!isValid && value != null) {
				onChange({
					target: {
						value: null
					}
				});
			}
		} catch (error: any) {
		};
	}
	useEffect(() => {
		setData([]);
		if (idTinhThanh && idTinhThanh > 0) {
			layDuLieu();
		}
	}, [idTinhThanh]);
	return (
		<Select
			style={{ width: '100%' }}
			showSearch
			placeholder="--Chọn phường/xã--"
			filterOption={function (search, item: any) {
				return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
			}}
			options={data}
			value={value}
			onChange={(e: number) => {
				onChange({
					target: {
						value: e
					}
				});
			}}
		/>
	);
};

export default PhuongXaSelectBox;
